import e from "@dialpad/dialtone-tokens/layered/themes/tokens-tmo-colors.css?inline";
//#region themes/tmo.js
var t = { brand: {
	css: e,
	name: "tmo"
} };
//#endregion
export { t as default };
